import { ReminderSettings } from '~models';
import { Handler } from '~services';
import { getField, updateField } from 'vuex-map-fields';
import { profile } from '~api';

const SET_REMINDER_SETTINGS = 'SET_REMINDER_SETTINGS';
const RESET_REMINDER_SETTINGS = 'RESET_REMINDER_SETTINGS';
const LOADING = 'LOADING';

const state = {
    reminder: { ...new ReminderSettings() },
    loading: false
};

const actions = {
    /**
     * Reset Settings state
     * @param {function} commit
     */
    cancel({ dispatch }) {
        dispatch('getRemindersSettings', { root: true });
    },
    /**
     * get reminderSettings state
     * @param {function} commit
     */
    async getRemindersSettings({ commit }) {
        const resp = await profile.getRemindersSettings();

        if (resp.ok && resp.data && Object.keys(resp.data).length) {
            const { remindAt, sendEmail, sendPush } = resp.data;
            commit(SET_REMINDER_SETTINGS, {
                remindAt,
                sendEmail,
                sendPush
            });
        }

        return Handler.handleResponse(resp);
    },

    async setRemindersSettings({ state, commit }) {
        const successMessage = 'Settings updated';
        const { reminder } = state;
        commit(LOADING);

        const resp = await profile.setRemindersSettings(reminder);

        if (resp.ok && resp.data && Object.keys(resp.data).length) {
            const { remindAt, sendEmail, sendPush } = resp.data;
            commit(SET_REMINDER_SETTINGS, {
                remindAt,
                sendEmail,
                sendPush
            });
        }

        return Handler.handleResponse(resp, successMessage);
    }
};

const mutations = {
    updateField,
    [SET_REMINDER_SETTINGS](state, data) {
        state.reminder = data;
    },
    [RESET_REMINDER_SETTINGS](state) {
        state.reminder = { ...new ReminderSettings() };
    },
    [LOADING](state) {
        state.isLoading = !state.isLoading;
    }
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    isLoading: state => state.isLoading
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
